import { defineComponent as _defineComponent } from 'vue'
import { HostRecommNew, encryptionLiveRecordList } from "@/api/php/home"
import { onMounted, ref } from "vue";
import MatchCell from "@/components/home/MatchCell.vue"

interface dataProps {
    type: number;
}

export default /*#__PURE__*/_defineComponent({
  name: 'HomeFootball',
  props: {
    type: { type: Number, required: true }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as {
    type: number;
}



onMounted(() => {
    if (props.type == 99) {
        getLiveList();
    } else {
        getData();
    }
});

const liveData = ref([])
const hasReqData = ref(false)
const getData = async () => {
    const res: any = await HostRecommNew({
        type: props.type,
        is_has_video: 0
    })
    if (res.code == 200 && res.data) {
        console.log(res.data);
        hasReqData.value = true
        let list = res.data.list || [];
        if (res.data.top_list) {
            list.unshift(res.data.top_list)
        }
        liveData.value = list;
    }
}

const getLiveList = async () => {
    const res: any = await encryptionLiveRecordList();
    console.log('getLiveList', res)
    if (res.code == 200 && res.data) {
        hasReqData.value = true
        liveData.value = res.data || [];
    }
}


const __returned__ = { props, liveData, hasReqData, getData, getLiveList, MatchCell }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})